import { Entity } from '@backstage/catalog-model';

export const ARGO_LABEL_SELECTOR_ANNOTATION = 'argo-workflows.io/label-selector';
export const ARGO_NAMESPACE_ANNOTATION = 'argo-workflows.io/namespace';
export const DEFAULT_NAMESPACE = 'argo';

export interface ArgoEntityBinding {
  namespace: string;
  labelSelector: string;
}

export function readArgoBinding(entity: Entity): ArgoEntityBinding | null {
  const labelSelector =
    entity.metadata.annotations?.[ARGO_LABEL_SELECTOR_ANNOTATION];
  if (!labelSelector) return null;
  const namespace =
    entity.metadata.annotations?.[ARGO_NAMESPACE_ANNOTATION] ?? DEFAULT_NAMESPACE;
  return { namespace, labelSelector };
}
